import { changePaginationSortOrder, getPaginationPageSize, getPaginationSortOrder } from '@/redux/modules/pagination';
import { changeSellerPagePast, changeSellerSearchTermsPast, getSellerViewData } from '@/redux/modules/viewData';
import {
    fetchDataForSellerPage,
    fetchDataForSellerPagePast,
    fetchDataForSellerPageRecordResults,
    fetchDataForSellerPageUpcoming,
} from '@/redux/modules/sellerPage';
import {
    fetchSellerLatestTopReviewsByIdIfNeeded,
    fetchSellerRatingSummaryByIdIfNeeded,
} from '@/redux/modules/sellerRatings';
import { getIsWhiteLabel, getWhiteLabelSellerId } from '@/redux/modules/whiteLabel';
import { parseQueryParams, validateQueryParams } from '@/utils/queryParams';
import { catalogSortOrders } from '@/enums';
import { DataLoaderParams } from '@/types/DataLoaderParams';
import { fetchAuctionNews } from '@/redux/modules/auctionNews';
import { fetchSellerFollowerCountIfNeeded } from '@/redux/modules/sellerFollowerCount';
import { fetchTopSellersIfNeeded } from '@/redux/modules/topRatedSellers';
import { getCategoryNameFromPathname } from '@/utils/urls';

export default ({ location, match, store }: DataLoaderParams) => {
    const { params } = match;
    const queryParams = parseQueryParams(location.search);
    const { dispatch, getState } = store;
    const state = getState();

    const whiteLabel = getIsWhiteLabel(state);

    const sellerId = whiteLabel ? getWhiteLabelSellerId(state) : Number(params.sellerId);
    const {
        page: pageFromUrl,
        sort: sortFromUrl,
        terms: termsFromUrl,
    } = validateQueryParams(queryParams, catalogSortOrders);

    if (!sellerId) {
        return Promise.resolve();
    }

    const pageSize = getPaginationPageSize(state);
    const { page: pageFromState, searchTerms: termsFromState } = getSellerViewData(state, sellerId, 'upcoming');
    const sortId = 'seller-catalogs-past';
    const sortFromState = getPaginationSortOrder(state, sortId) || catalogSortOrders.DATE_DESCENDING;

    const promises = [
        dispatch(fetchDataForSellerPage(sellerId)),
        dispatch(fetchDataForSellerPageUpcoming(sellerId)),
        dispatch(fetchDataForSellerPagePast(sellerId, pageFromUrl, pageSize, termsFromUrl, sortFromUrl)),
        dispatch(fetchDataForSellerPageRecordResults(sellerId)),
        dispatch(fetchSellerFollowerCountIfNeeded([sellerId])),
        dispatch(fetchTopSellersIfNeeded()),
        dispatch(fetchSellerRatingSummaryByIdIfNeeded(sellerId)),
        dispatch(fetchSellerLatestTopReviewsByIdIfNeeded(sellerId)),
        dispatch(fetchAuctionNews(getCategoryNameFromPathname(location.pathname))),
    ];

    if (pageFromState !== pageFromUrl) {
        promises.push(dispatch(changeSellerPagePast(sellerId, pageFromUrl)));
    }
    if (sortFromState !== sortFromUrl) {
        promises.push(dispatch(changePaginationSortOrder(sortId, sortFromUrl)));
    }
    if (termsFromState !== termsFromUrl) {
        promises.push(dispatch(changeSellerSearchTermsPast(sellerId, termsFromUrl)));
    }

    return Promise.all(promises);
};
